export default __webpack_public_path__ + "static/media/gallery_14.e118acd2.jpg";